import { APIResponse } from '@fastlessjs/backoffice-layer/dist/hooks';
import { request } from '@fastlessjs/backoffice-layer/dist/hooks/stores/helpers';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { useQuery } from '@tanstack/react-query';

import { APIOptions } from '../../types';
import { Product } from '../types';

// Register this module for debug tracking
debug.registerComponent('products-hooks');

/**
 * REQUESTS
 */

const getProduct = async (options?: APIOptions) => {
  debug.log('products-hooks', `Fetching product: ${options?.productId}`);

  try {
    const result = await request(`/products/${options?.productId}`, {
      method: 'get',
    });
    debug.log('products-hooks', `Product fetched successfully: ${options?.productId}`);
    return result;
  } catch (error) {
    debug.error(
      'products-hooks',
      `Error fetching product ${options?.productId}: ${error}`,
    );
    throw error;
  }
};

/**
 * HOOKS
 */

const useProduct = (options?: APIOptions) => {
  debug.trackAccess('useProduct', 'hook execution');
  debug.log('useProduct', `Hook called with productId: ${options?.productId}`);

  return useQuery({
    queryKey: ['product', options?.productId],
    queryFn: () => getProduct(options),
    select: (response: APIResponse<Product>) => {
      debug.log('useProduct', `Selecting product data from response`);
      return response.data;
    },
    enabled: !!options?.productId,
  });
};

export { useProduct };

// Mark this module as initialized
debug.markInitialized('products-hooks');
